// extracted by mini-css-extract-plugin
export default {"form":"SoeJw","button":"Vwvy1"};